import {NormalizerI} from "./normalizer.i";
import {isNaN} from 'lodash';

export class PercentageDecimalNormalizer implements NormalizerI {

    normalize(model): string {
        model = model.toString();

        if (((model.indexOf('.') == 1) && (model.length == 2))
            || ((model.indexOf('.') == 2) && (model.length == 3))) {
            return model;
        }

        if (model.match(/[^.\d]/) ||
            model.replace(/[^.]/g, "").length > 1 ||
            model.match(/^0\d/)) {
            return model.substring(0, model.length - 1);
        }

        const percentage = parseFloat(model);
        if (!isNaN(percentage)) {
            if (model.length > 5 && (model.indexOf('.') == 2)) {
                model = model.substring(0, 5);
            }

            if (model.length > 4 && (model.indexOf('.') == 1)) {
                model = model.substring(0, 4);
            }

            if (percentage >= 0 && percentage <= 100) {
                return model;
            }

            if (percentage < 0) {
                return '0';
            }

            if (percentage > 100) {
                if (model.startsWith('100')) {
                    return '100';
                }
                return model.substring(0, 2);
            }
        }
        return model.substring(0, model.length - 1);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/normalizers/percentage-decimal.normalizer.ts